import styled from 'styled-components';
import defaultTheme from './defaultTheme';

export const Modal = styled.div`
  max-width: ${(p) => p.width};
  height: ${(p) => p.height};
  position: ${(p) => p.position};
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 1px 3px 8px 0 ${(p) => p?.theme?.colors?.primary?.whiteBoxShadow ?? defaultTheme.colors.primary.whiteBoxShadow}50;
  padding: 30px;
  border: 1px solid ${(p) => p?.theme?.colors?.custom?.paleGrey ?? defaultTheme.colors.custom.paleGrey};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 0 10px 30px;
}
`;

export const Icon = styled.span`
  cursor: pointer;
  align-self: flex-end;
  font-weight: 800;
`;
